<template>
  <div>
    <h3 class="page-title">
      {{ $t('registration.congratulation') }}<br>
      {{ $t('registration.youAreMemberOfGoGo') }}
    </h3>

    <div class="confirm-content">
      <div class="row">
        <div class="col-sm-8 offset-sm-2">
          <i18n-t
            keypath="registration.requestServicesByCalling"
            tag="p"
            class="page-description"
          >
            <template #callPhoneNumber>
              <a
                href="tel:+18554646872"
                style="display: inline-block"
              > 1 (855) 464 6872 </a>
            </template>
            <template #dashboardLink>
              <a href="https://app.gogograndparent.com">{{ $t('registration.clientDashboard') }}</a>
            </template>
          </i18n-t>

          <img :src="phoneMenuPath">
        </div>
      </div>

      <div class="row">
        <div class="col-sm-8 offset-sm-2">
          <h3 class="text-center mb-3">
            {{ $t('registration.faq') }}
          </h3>

          <p class="text-justify">
            <b>{{ $t('registration.question') }}:</b> {{ $t('registration.question1') }}
          </p>
          <p class="text-justify">
            <b>{{ $t('registration.answer') }}:</b> {{ $t('registration.answer1') }}
          </p>
          <br>

          <p>
            <b>{{ $t('registration.question') }}:</b> {{ $t('registration.question2') }}
          </p>
          <p class="text-justify">
            <b>{{ $t('registration.answer') }}:</b> {{ $t('registration.answer2') }}
          </p>
          <br>

          <p>
            <b>{{ $t('registration.question') }}:</b> {{ $t('registration.question3') }}
          </p>
          <p class="text-justify">
            <b>{{ $t('registration.answer') }}:</b> {{ $t('registration.answer3') }}
          </p>
        </div>
      </div>

      <div class="row m-mt-30">
        <div class="col-sm-8 offset-sm-2">
          <i18n-t
            keypath="registration.haveAnyQuestions"
            tag="h3"
            class="mb-3 text-center"
          >
            <template #callPhoneNumber>
              <a
                href="tel:+18554646872"
                style="display: inline-block"
              > 1 (855) 464 6872 </a>
            </template>
          </i18n-t>
          <i18n-t
            keypath="registration.youCanAlsoEmailUs"
            tag="p"
          >
            <template #email>
              <a
                href="mailto:support@gogograndparent.com"
                style="display: inline-block"
              > support@gogograndparent.com </a>
            </template>
          </i18n-t>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

export default {
  name: 'Confirmation',
  props: {
    customerInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  setup: () => {
    const { locale } = useI18n();

    const phoneMenuPath = computed(() => {
      const isEnglishVersion = locale.value === 'en';

      if (isEnglishVersion) {
        return '/static/img/phone_menu_en.png';
      }

      return '/static/img/phone_menu_es.png';
    });

    return { phoneMenuPath };
  },
};
</script>

<style lang="scss">
.page-description {
  font-size: 20px;
  text-align: center;
  line-height: 24px;
  margin-bottom: 20px;
  margin-top: 10px;
  color: #73040c;

  a {
    display: inline-block;
  }
}
@media (max-width: 576px) {
  .confirm-content {
    margin: 0 15px;
  }

  .page-description {
    font-size: 16px;
    line-height: 18px;
  }
}
</style>
